import { Component } from '@angular/core';
import { GetProjectProcessParams } from '../project-process.component';
import { StateService } from '@app/core/services/state.service';

@Component({
    selector: 'tt-project-process-view',
    templateUrl: './project-process-view.component.html',
    styleUrls: ['./project-process-view.component.css'],
})
export class ProjectProcessViewComponent {
    params: GetProjectProcessParams;

    constructor(public state: StateService) {
        this.params = state.getStateParams() as unknown as GetProjectProcessParams;
    }
}
